module.exports = __webpack_public_path__ + "media/images/donations/americanexpress-c8213f82b2787b38b316745f1e9b9abb.png";